import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDStack,
  FDPrimaryActionIconButton,
  FDPrimaryActionButton,
} from '@facet-wealth/design';
import { useNavigationContext } from 'Components/ComponentLibrary/Organisms/NavigationWithContext/NavigationContext';
import Proptypes from 'prop-types';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import fr from 'facet-rest';
import { DialogContent, DialogActions } from 'Views/Page/Content/Modal/Components';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { dataAttrs } from 'Helpers/Testing';
import metaOverrideSet from './metaOverrideSet';

// This is a simple component meant to be used as a very *light* wrapper for our PX wizard modals so that they can
// fully use FD components.

/**
 * @deprecated use PXFormModalWrapper instead for wrapping modals with form inputs
 */
const FDWizardModalWrapper = ({ resource, children, primaryButtonLabel }) => {
  const { onSubmit, saving } = useMetaLayoutContext();
  const { refreshNavigationCollection } = useNavigationContext();
  const { loadModalCollectionByLink } = useModalContext();

  const handleContinue = async () => {
    await onSubmit();
    refreshNavigationCollection();
  };

  return (
    <>
      <MetaControlField attr={'title'} resource={resource} metaOverrideSet={metaOverrideSet} />
      <DialogContent scrollKey={resource?.type() + resource?.id()}>
        <FDStack direction="column" spacing={3}>
          <MetaControlField attr={'subtitle'} resource={resource} metaOverrideSet={metaOverrideSet} />
          {children}
        </FDStack>
      </DialogContent>
      <DialogActions>
        {resource.withRelationship(fr.relationships.previousLink.name,
          (rel) => (
            <FDPrimaryActionIconButton
              icon="chevronLeft"
              onClick={() => {
                loadModalCollectionByLink(rel.link('related').url());
              }}
            />
          ),
          () => null)}
        {resource.meta().canPost() ? <FDPrimaryActionButton
          {...dataAttrs('continue-btn', resource)}
          label={primaryButtonLabel}
          onClick={handleContinue}
          disabled={saving}
        /> : null}
      </DialogActions>
    </>
  );
};

FDWizardModalWrapper.propTypes = {
  children: Proptypes.any.isRequired,
  resource: Proptypes.object.isRequired,
  primaryButtonLabel: Proptypes.string,
};

FDWizardModalWrapper.defaultProps = {
  primaryButtonLabel: 'Continue',
};

export default FDWizardModalWrapper;
